import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Shield, TrendingUp, Users, AlertTriangle, Search, Filter, ChevronRight, Eye, MessageSquare, Share2, CheckCircle, Clock, MapPin, Building } from 'lucide-react';
export function AdvocacyPage() {
  const [searchQuery, setSearchQuery] = useState('');
  const [filterCategory, setFilterCategory] = useState('All Issues');
  const [filterLocation, setFilterLocation] = useState('All Locations');
  const trendingIssues = [{
    id: 1,
    title: 'Delayed Possession - Green Valley Phase 2',
    project: 'Green Valley Phase 2',
    developer: 'ABC Developers',
    location: 'Hinjewadi, Pune',
    category: 'Possession Delay',
    postCount: 24,
    views: 1847,
    status: 'Trending',
    severity: 'high',
    lastUpdate: '2 hours ago'
  }, {
    id: 2,
    title: 'Missing Infrastructure Promises',
    project: 'Sunrise Heights',
    developer: 'XYZ Constructions',
    location: 'Whitefield, Bangalore',
    category: 'Infrastructure',
    postCount: 18,
    views: 1432,
    status: 'Trending',
    severity: 'medium',
    lastUpdate: '5 hours ago'
  }, {
    id: 3,
    title: 'Unauthorized Construction Charges',
    project: 'Metro Residency',
    developer: 'Metro Builders',
    location: 'Gurgaon',
    category: 'Financial',
    postCount: 15,
    views: 1156,
    status: 'Under Review',
    severity: 'high',
    lastUpdate: '1 day ago'
  }];
  const recentPosts = [{
    id: 1,
    title: 'No Water Connection After 3 Years',
    author: 'Verified Buyer',
    project: 'Green Valley Phase 2',
    location: 'Pune',
    category: 'Infrastructure',
    date: '2024-01-20',
    views: 234,
    comments: 12,
    verified: true,
    status: 'Live'
  }, {
    id: 2,
    title: 'Builder Refusing to Provide OC',
    author: 'Verified Buyer',
    project: 'Sunrise Heights',
    location: 'Bangalore',
    category: 'Documentation',
    date: '2024-01-19',
    views: 189,
    comments: 8,
    verified: true,
    status: 'Live'
  }, {
    id: 3,
    title: 'Road Access Blocked by Developer',
    author: 'Verified Buyer',
    project: 'Metro Residency',
    location: 'Gurgaon',
    category: 'Access Issues',
    date: '2024-01-18',
    views: 156,
    comments: 15,
    verified: true,
    status: 'Live'
  }];
  const stats = [{
    label: 'Active Issues',
    value: '247',
    icon: AlertTriangle
  }, {
    label: 'Verified Posts',
    value: '1,842',
    icon: CheckCircle
  }, {
    label: 'Projects Tracked',
    value: '156',
    icon: Building
  }, {
    label: 'Buyers Empowered',
    value: '3,421',
    icon: Users
  }];
  const filteredPosts = recentPosts.filter(post => {
    const matchesSearch = searchQuery === '' || post.title.toLowerCase().includes(searchQuery.toLowerCase()) || post.project.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesCategory = filterCategory === 'All Issues' || post.category === filterCategory;
    const matchesLocation = filterLocation === 'All Locations' || post.location === filterLocation;
    return matchesSearch && matchesCategory && matchesLocation;
  });
  return <div className="min-h-screen bg-[#f5f5f7] font-sans text-[#1f2933] flex flex-col" data-id="element-2045">
      {/* Header */}
      <header className="bg-white border-b border-gray-300 py-4 px-6 md:px-12 sticky top-0 z-10" data-id="element-2046">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-2047">
          <Link to="/" className="flex items-center gap-2" data-id="element-2048">
            <div className="w-8 h-8 bg-[#1f2933] rounded-sm" data-id="element-2049"></div>
            <span className="font-bold text-xl tracking-tight" data-id="element-2050">
              Citiplots.com
            </span>
          </Link>
          <nav className="hidden md:flex gap-8 text-sm font-medium text-gray-600" data-id="element-2051">
            <Link to="/" data-id="element-2052">Buy Plots</Link>
            <Link to="/create-listing" data-id="element-2053">Sell Land</Link>
            <Link to="/legal-guides" data-id="element-2054">Legal Guides</Link>
            <Link to="/advocacy" className="text-[#1f2933]" data-id="element-2055">
              Advocacy
            </Link>
          </nav>
          <div className="flex items-center gap-4" data-id="element-2056">
            <Link to="/advocacy/submit" className="px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-2057">
              Share Your Experience
            </Link>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="bg-white border-b border-gray-300 py-16 px-6 md:px-12" data-id="element-2058">
        <div className="max-w-5xl mx-auto text-center" data-id="element-2059">
          <div className="flex justify-center mb-6" data-id="element-2060">
            <Shield className="w-16 h-16 text-gray-400" data-id="element-2061" />
          </div>
          <h1 className="text-5xl font-bold mb-6 tracking-tight" data-id="element-2062">
            Buyer Advocacy Platform
          </h1>
          <p className="text-xl text-gray-500 mb-8 max-w-3xl mx-auto font-mono" data-id="element-2063">
            Empowering verified plot buyers to share challenges, caution peers,
            and hold developers accountable through transparent, public
            advocacy.
          </p>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto" data-id="element-2064">
            {stats.map((stat, i) => {
            const Icon = stat.icon;
            return <div key={i} className="p-6 border border-gray-300 bg-gray-50" data-id="element-2065">
                  <Icon className="w-6 h-6 text-gray-400 mx-auto mb-3" data-id="element-2066" />
                  <div className="text-3xl font-bold mb-1" data-id="element-2067">{stat.value}</div>
                  <div className="text-xs text-gray-500 font-mono" data-id="element-2068">
                    {stat.label}
                  </div>
                </div>;
          })}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <main className="flex-1 max-w-7xl mx-auto px-6 py-12 w-full" data-id="element-2069">
        {/* Search & Filters */}
        <div className="bg-white border border-gray-300 p-6 mb-8" data-id="element-2070">
          <div className="flex flex-col md:flex-row gap-4" data-id="element-2071">
            <div className="relative flex-1" data-id="element-2072">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-2073" />
              <input type="text" placeholder="Search issues, projects, or developers..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500 text-sm" data-id="element-2074" />
            </div>
            <select value={filterCategory} onChange={e => setFilterCategory(e.target.value)} className="px-4 py-3 border border-gray-300 bg-white text-sm font-medium focus:outline-none focus:border-gray-500" data-id="element-2075">
              <option data-id="element-2076">All Issues</option>
              <option data-id="element-2077">Possession Delay</option>
              <option data-id="element-2078">Infrastructure</option>
              <option data-id="element-2079">Documentation</option>
              <option data-id="element-2080">Financial</option>
              <option data-id="element-2081">Access Issues</option>
            </select>
            <select value={filterLocation} onChange={e => setFilterLocation(e.target.value)} className="px-4 py-3 border border-gray-300 bg-white text-sm font-medium focus:outline-none focus:border-gray-500" data-id="element-2082">
              <option data-id="element-2083">All Locations</option>
              <option data-id="element-2084">Pune</option>
              <option data-id="element-2085">Bangalore</option>
              <option data-id="element-2086">Gurgaon</option>
              <option data-id="element-2087">Mumbai</option>
              <option data-id="element-2088">Hyderabad</option>
            </select>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-2089">
          {/* Main Content - Posts */}
          <div className="lg:col-span-2 space-y-6" data-id="element-2090">
            <div className="flex justify-between items-center" data-id="element-2091">
              <h2 className="text-2xl font-bold" data-id="element-2092">Recent Advocacy Posts</h2>
              <Link to="/advocacy/trending" className="text-sm font-bold text-blue-600 hover:underline flex items-center gap-1" data-id="element-2093">
                View Trending <ChevronRight className="w-4 h-4" data-id="element-2094" />
              </Link>
            </div>

            {filteredPosts.map(post => <div key={post.id} className="bg-white border border-gray-300 p-6 hover:shadow-md transition-shadow" data-id="element-2095">
                <div className="flex items-start justify-between mb-3" data-id="element-2096">
                  <div className="flex-1" data-id="element-2097">
                    <div className="flex items-center gap-2 mb-2" data-id="element-2098">
                      {post.verified && <span className="px-2 py-0.5 bg-green-100 text-green-800 border border-green-200 text-xs font-bold rounded" data-id="element-2099">
                          VERIFIED BUYER
                        </span>}
                      <span className="px-2 py-0.5 bg-blue-100 text-blue-800 border border-blue-200 text-xs font-bold rounded" data-id="element-2100">
                        {post.status.toUpperCase()}
                      </span>
                    </div>
                    <Link to={`/advocacy/post/${post.id}`} className="text-xl font-bold hover:text-blue-600 block mb-2" data-id="element-2101">
                      {post.title}
                    </Link>
                    <div className="flex items-center gap-4 text-sm text-gray-600" data-id="element-2102">
                      <span className="flex items-center gap-1" data-id="element-2103">
                        <Building className="w-4 h-4" data-id="element-2104" />
                        {post.project}
                      </span>
                      <span className="flex items-center gap-1" data-id="element-2105">
                        <MapPin className="w-4 h-4" data-id="element-2106" />
                        {post.location}
                      </span>
                      <span className="px-2 py-0.5 bg-gray-100 text-gray-700 text-xs font-bold" data-id="element-2107">
                        {post.category}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="flex items-center justify-between pt-4 border-t border-gray-200" data-id="element-2108">
                  <div className="flex items-center gap-4 text-sm text-gray-500" data-id="element-2109">
                    <span className="flex items-center gap-1" data-id="element-2110">
                      <Eye className="w-4 h-4" data-id="element-2111" />
                      {post.views}
                    </span>
                    <span className="flex items-center gap-1" data-id="element-2112">
                      <MessageSquare className="w-4 h-4" data-id="element-2113" />
                      {post.comments}
                    </span>
                    <span className="flex items-center gap-1" data-id="element-2114">
                      <Clock className="w-4 h-4" data-id="element-2115" />
                      {post.date}
                    </span>
                  </div>
                  <button className="text-sm font-bold text-gray-600 hover:text-gray-900 flex items-center gap-1" data-id="element-2116">
                    <Share2 className="w-4 h-4" data-id="element-2117" />
                    Share
                  </button>
                </div>
              </div>)}

            {filteredPosts.length === 0 && <div className="bg-white border border-gray-300 p-12 text-center" data-id="element-2118">
                <AlertTriangle className="w-12 h-12 text-gray-300 mx-auto mb-4" data-id="element-2119" />
                <p className="text-gray-500 font-mono" data-id="element-2120">
                  No posts found matching your criteria
                </p>
              </div>}
          </div>

          {/* Sidebar - Trending Issues */}
          <div className="space-y-6" data-id="element-2121">
            <div className="bg-white border border-gray-300 p-6" data-id="element-2122">
              <h3 className="font-bold text-lg mb-4 flex items-center gap-2" data-id="element-2123">
                <TrendingUp className="w-5 h-5" data-id="element-2124" />
                Trending Issues
              </h3>
              <div className="space-y-4" data-id="element-2125">
                {trendingIssues.map(issue => <Link key={issue.id} to={`/advocacy/trending/${issue.id}`} className="block p-4 border border-gray-200 hover:bg-gray-50" data-id="element-2126">
                    <div className="flex items-start justify-between mb-2" data-id="element-2127">
                      <span className={`px-2 py-0.5 text-xs font-bold rounded ${issue.severity === 'high' ? 'bg-red-100 text-red-800 border border-red-200' : 'bg-yellow-100 text-yellow-800 border border-yellow-200'}`} data-id="element-2128">
                        {issue.severity === 'high' ? 'HIGH SEVERITY' : 'MEDIUM SEVERITY'}
                      </span>
                    </div>
                    <h4 className="font-bold text-sm mb-2" data-id="element-2129">{issue.title}</h4>
                    <p className="text-xs text-gray-600 mb-3" data-id="element-2130">
                      {issue.project}
                    </p>
                    <div className="flex items-center justify-between text-xs text-gray-500" data-id="element-2131">
                      <span data-id="element-2132">{issue.postCount} posts</span>
                      <span data-id="element-2133">{issue.views} views</span>
                    </div>
                  </Link>)}
              </div>
            </div>

            {/* CTA Box */}
            <div className="bg-blue-50 border border-blue-200 p-6" data-id="element-2134">
              <h3 className="font-bold mb-3" data-id="element-2135">Have an Issue to Report?</h3>
              <p className="text-sm text-gray-700 mb-4" data-id="element-2136">
                Share your experience to help other buyers and hold developers
                accountable.
              </p>
              <Link to="/advocacy/submit" className="block w-full py-3 bg-[#1f2933] text-white text-center text-sm font-bold hover:bg-gray-800" data-id="element-2137">
                Submit Advocacy Post
              </Link>
              <p className="text-xs text-gray-500 mt-3 text-center" data-id="element-2138">
                Requires buyer verification
              </p>
            </div>

            {/* Info Box */}
            <div className="bg-white border border-gray-300 p-6" data-id="element-2139">
              <h3 className="font-bold mb-3" data-id="element-2140">How Advocacy Works</h3>
              <ul className="space-y-3 text-sm text-gray-700" data-id="element-2141">
                <li className="flex items-start gap-2" data-id="element-2142">
                  <CheckCircle className="w-4 h-4 text-green-600 shrink-0 mt-0.5" data-id="element-2143" />
                  <span data-id="element-2144">All posts are verified and moderated</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-2145">
                  <CheckCircle className="w-4 h-4 text-green-600 shrink-0 mt-0.5" data-id="element-2146" />
                  <span data-id="element-2147">Public visibility for accountability</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-2148">
                  <CheckCircle className="w-4 h-4 text-green-600 shrink-0 mt-0.5" data-id="element-2149" />
                  <span data-id="element-2150">Connect with affected buyers</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-2151">
                  <CheckCircle className="w-4 h-4 text-green-600 shrink-0 mt-0.5" data-id="element-2152" />
                  <span data-id="element-2153">Media and civic organization access</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-2154" />
    </div>;
}